import { QIcon, QStack, QText } from '@qualio/ui-components';
import { EventTag } from '../../../types';

export const TagItemLabel = ({ tag }: { tag: EventTag }) => {
  return (
    <QStack display="inline-flex" direction="row" align="center">
      <QText isTruncated margin="auto">
        {tag.name}
      </QText>
      {!!tag.group_ids?.length && <QIcon iconName="Lock" size="xs" />}
    </QStack>
  );
};

export default TagItemLabel;
